/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener("DOMContentLoaded", function(event) {

  /* Announcement Bar */
  $(document).on('click', '.js-AnnouncementBar__Close', function () {
    $('.AnnouncementBar').hide();
  });

  /* Why Us Slider */
  if ($('.WhyUs__Blocks').length > 0) {
    let flickity = null;
    const slideshowEl = document.querySelector('.WhyUs__Blocks');

    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25
    });
  }

  /* Collection - Scroll Down */
  $(document).on('click', '.js-Collection__ScrollDown', function () {
    $('html,body').animate({
      scrollTop: $('.Collection__Header').height()
    }, 500, 'swing');
  });

  $(window).scroll(function() {
    if (window.scrollY >= 10) {
      if (!$('body').hasClass('is-sticky')) {
        $('body').addClass('is-sticky');
      }
    }
    else {
      $('body').removeClass('is-sticky');
    }
  });

  /* PDP - Tabs */
  $(document).on('click', '.js-ProductTab__Button', function () {
    var index = $(this).attr('data-index');
    $('.ProductTab__Button.active').removeClass('active');
    $('.ProductTab__Content.active').removeClass('active');
    $(this).addClass('active');
    $(`.ProductTab__Content[data-index="${index}"]`).addClass('active');
  });

  var fitOiiDiscover = () => {
    var height = 0;

    $('.oil-discover-item .info-content .description').each(function () {
        $this = $(this);
        if ( $this.height() > height ) {
          height = $this.height();
        }
    });
    $('.oil-discover-item .info-content .description').height(height);
  }

  fitOiiDiscover();
  $(window).resize(function() {
    $('.oil-discover-item .info-content .description').height('auto');
    fitOiiDiscover();
  });
});